import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import { TextInput, Button, StatusSwitch } from 'streamlabs-beaker';
import Position from './Position.vue';
import GeneralSettings from './GeneralSettings.vue';
import VisibilityDeleteComponentButton from './VisibilityDeleteComponentButton.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import { EModalName } from '@/helpers/modal';
import UserApi from '@/apis/user-api';
import { EComponentType, ISLWidgetComponent } from '@/helpers/editor';
import { startCase } from 'lodash';

@Component({
  components: {
    STextInput: TextInput,
    SButton: Button,
    Position,
    GeneralSettings,
    VisibilityDeleteComponentButton,
    ConfirmationModal,
    SStatusSwitch: StatusSwitch,
  },
})
export default class SLWidgetSettings extends EditorBase {
  get icon(): string {
    switch (this.selectedComponent.type) {
      case EComponentType.chat:
        return 'icon-chat-box';
      case EComponentType.eventList:
        return 'icon-event-list';
      case EComponentType.alertBox:
      default:
        return 'icon-notifications';
    }
  }

  get title(): string {
    return startCase(this.selectedComponent.type);
  }

  openStreamlabsAlertboxSetting() {
    let settingUrl = null;
    switch (this.selectedComponent.type) {
      case EComponentType.chat:
        settingUrl = 'https://streamlabs.com/dashboard/chatbox';
        break;
      case EComponentType.eventList:
        settingUrl = 'https://streamlabs.com/dashboard/eventlist';
        break;
      case EComponentType.alertBox:
      default:
        settingUrl = 'https://streamlabs.com/dashboard/alertbox';
        break;
    }

    window.open(settingUrl);
  }

  openConnectStreamlabs() {
    this.$modal.show(EModalName.connectStreamlabsModal);
  }

  async toggleUseSLSettings() {
    const useSLSettings = !(this.selectedComponent as ISLWidgetComponent).useSLSettings;
    await this.onComponentUpdate({ ...this.selectedComponent, ...{ useSLSettings } });
  }
}
